var map = {
	"./de_DE.json": 766,
	"./en_AU.json": 767,
	"./en_CA.json": 768,
	"./en_GB.json": 769,
	"./es_AR.json": 770,
	"./es_ES.json": 771,
	"./es_MX.json": 772,
	"./fr_CA.json": 773,
	"./fr_FR.json": 774,
	"./it_IT.json": 775,
	"./nl_NL.json": 776,
	"./pt_BR.json": 777,
	"./pt_PT.json": 778
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 765;